'use client';
import WaveSurferPlayer from './WaveSurferPlayer';

const AudioRenderer = ({ url }: { url: string }) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  // Define the waveform gradient
  const gradient = ctx?.createLinearGradient(0, 0, 0, canvas.height * 1.35);
  gradient?.addColorStop(0, '#656666'); // Top color
  gradient?.addColorStop((canvas.height * 0.7) / canvas.height, '#656666'); // Top color
  gradient?.addColorStop((canvas.height * 0.7 + 1) / canvas.height, '#ffffff'); // White line
  gradient?.addColorStop((canvas.height * 0.7 + 2) / canvas.height, '#ffffff'); // White line
  gradient?.addColorStop((canvas.height * 0.7 + 3) / canvas.height, '#B1B1B1'); // Bottom color
  gradient?.addColorStop(1, '#B1B1B1'); // Bottom color

  // Define the progress gradient
  const progressGradient = ctx?.createLinearGradient(0, 0, 0, canvas.height * 1.35);
  progressGradient?.addColorStop(0, '#EE772F'); // Top color
  progressGradient?.addColorStop((canvas.height * 0.7) / canvas.height, '#EB4926'); // Top color
  progressGradient?.addColorStop((canvas.height * 0.7 + 1) / canvas.height, '#ffffff'); // White line
  progressGradient?.addColorStop((canvas.height * 0.7 + 2) / canvas.height, '#ffffff'); // White line
  progressGradient?.addColorStop((canvas.height * 0.7 + 3) / canvas.height, '#F6B094'); // Bottom color
  progressGradient?.addColorStop(1, '#F6B094'); // Bottom color

  return (
    <WaveSurferPlayer
      url={url}
      waveColor={gradient}
      progressColor={progressGradient}
      cursorColor="rgb(0, 0, 0)"
      dragToSeek={true}
      cursorWidth={2}
      minPxPerSec={100}
      fillParent={false}
      barWidth={2}
      fetchParams={{ credentials: 'include' }}
      // barHeight={2}
      normalize
    />
  );
};

export default AudioRenderer;
